
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="editForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="rating_scale_value">Rating Scale Value</label>
    <div class="col-8">
      <input type="number" id="rating_scale_value" formControlName="rating_scale_value" class="form-control"
        min="0" step="1" appIntegerOnly>


      <div *ngIf="rating_scale_value?.invalid" class="alert alert-danger">
        <div *ngIf="rating_scale_value?.errors?.['required']">Value is required.</div>
<!--        <div *ngIf="rating_scale_value?.errors?.['min']">Value must be greater than -1.</div>-->
<!--        <div *ngIf="rating_scale_value?.errors?.['min'] || rating_scale_value?.errors?.['pattern']">-->
<!--          Only positive numbers with no decimals allowed.-->
<!--        </div>-->
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="rating_scale_name">Scale Title</label>
    <div class="col-8">
      <input type="text" id="rating_scale_name" formControlName="rating_scale_name" class="form-control" appAutoFocus>
      <div *ngIf="rating_scale_name?.invalid" class="alert alert-danger">
        <div *ngIf="rating_scale_name?.errors?.['required']">Scale Title is required.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="rating_scale_description">Description</label>
    <div class="col-8">
      <textarea class="form-control" id="rating_scale_description"  formControlName="rating_scale_description" rows="4"  style="width:100%;"></textarea >
      <div *ngIf="rating_scale_description?.invalid" class="alert alert-danger">
        <div *ngIf="rating_scale_description?.errors?.['required']">Description is required.</div>
      </div>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="editForm.errors?.['duplicateEvaluationRatingScale']">
    That evaluation rating scale already exists.
  </div>
</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
